module.exports = __webpack_public_path__ + "static/media/moon.1060be38.jpg";